import CONSTANTS from 'src/utils/constants';

export const IN_TAX_APPROVAL = CONSTANTS.APPROVAL_WORKFLOW_STAGES.IN_TAX_APPROVAL;
export const ACTIVE = CONSTANTS.APPROVAL_WORKFLOW_STAGES.ACTIVE;
export const INACTIVE = CONSTANTS.APPROVAL_WORKFLOW_STAGES.INACTIVE;
export const TERMINATED = CONSTANTS.APPROVAL_WORKFLOW_STAGES.TERMINATED;
export const ACCOUNTING_APPROVER_UNDEFINED = undefined;
export const TAX_APPROVER_UNDEFINED = undefined;
export const CANCELLED_BY_UNDEFINED = undefined;
export const DEACTIVATED_BY_UNDEFINED = undefined;
export const REACTIVATED_BY_UNDEFINED = undefined;

export const VISIBLE_CHANGE_FIELDS = {
  atpCalculationFlag: 'ATP Calculation Flag',
  currency: 'Currency',
  effectiveFromDate: 'Effective Start Date',
  effectiveToDate: 'Effective End Date',
  workbookName: 'Workbook Name',
  beat: 'BEAT Indicator',
  description: 'Description of Transaction',
  comments: 'Comments',
  paymentTerms: 'Payment Terms',
  providerTaxRegConsideration: 'Provider Tax Reg Consideration',
  recipientTaxRegConsideration: 'Recipient Tax Reg Consideration',
  taxProductCategoryName: 'Tax Product Category Name',
  taxProductCategoryId: 'Tax Product Category ID',
  taxProductName: 'Tax Product Sub Category Name',
  taxProductId: 'Tax Product Sub Category ID',
  exportOfServices: 'Export of Services',
  providerPlAccounts: 'Provider Offset Accounts',
  recipientPlAccounts: 'Recipient Offset Accounts',
  accountingPoc: 'Accounting POC',
};
